import React, { useState, useCallback, useEffect } from "react";
import Autocomplete, { AutocompleteResult } from "./Autocomplete";
import { Directions } from "./primitives";

export interface AutocompleteSet {
	changed: boolean;
	from: AutocompleteResult;
	to: AutocompleteResult;
}

interface FromToEditorProps {
	mapRef: React.RefObject<L.Map>;
	onAdd: (set: AutocompleteSet) => void;
	onClear: () => void;
	result?: Directions | null;
}

const FromToEditor = ({
	mapRef,
	onAdd,
	result,
	onClear,
}: FromToEditorProps) => {
	const [coords, setCoords] = useState<Partial<AutocompleteSet>>(
		result
			? {
					from: {
						text: result.fromLabel,
						latlng: result.from,
					},
					to: {
						text: result.toLabel,
						latlng: result.to,
					},
			  }
			: {}
	);
	const onSwitch = useCallback(() => {
		setCoords((coords) => {
			return {
				changed: true,
				to: coords.from,
				from: coords.to,
			};
		});
	}, []);
	useEffect(() => {
		if (coords.from && coords.to) {
			if (coords.changed) onAdd(coords as AutocompleteSet);
		} else {
			onClear();
		}
	}, [coords]);
	return (
		<div className="directions">
			<Autocomplete
				result={coords.from}
				onSelect={(result?: AutocompleteResult) => {
					setCoords((state) => ({ ...state, from: result, changed: true }));
				}}
				mapRef={mapRef}
				name="from"
			/>
			<button onClick={onSwitch}>🔁</button>
			<Autocomplete
				result={coords.to}
				onSelect={(result?: AutocompleteResult) =>
					setCoords((state) => ({ ...state, to: result, changed: true }))
				}
				mapRef={mapRef}
				name="to"
			/>
		</div>
	);
};

export default FromToEditor;
